module.exports = __webpack_public_path__ + "img/Bear03.2f524531.jpg";